import { Container, createStyles, Grid, makeStyles, Typography } from "@material-ui/core"
import React from "react"


type Props = {

}

export const Schools = (props: Props) => {
    const classes = useStyles({});
    return (
        <div className={classes.section}>
            <Container maxWidth='md'>
                <Typography gutterBottom
                    variant='h3' align='center'>Where is Flutter Available?</Typography>
                <Typography gutterBottom align='center' variant='h6'>We are focused on building density of users in select locations. Flutter is currently available to users near the following campuses.</Typography>
                <Grid container spacing={2}>
                    <Grid xs={12} item>
                        <div className={classes.item}>
                            <img src={'https://images.thestar.com/W5RXrP-B-_WSBhA147dmDMufJeA=/1086x688/smart/filters:cb(2700061000)/https://www.thespec.com/content/dam/thespec/opinion/columnists/2018/02/28/mcmaster-university-completes-probe-into-anti-semitic-remarks/B8872228Z.1_20180227190903_000_GF53GJFV.2-0_Gallery.jpg'}
                                alt='mcmaster' />
                            <div className='title'>
                                <Typography variant='h3'>McMaster</Typography>
                                <Typography variant='h6'>Hamilton</Typography>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}

const useStyles = makeStyles(theme => createStyles({
    section: {
        padding: theme.spacing(6, 0),
    },
    item: {
        borderRadius: theme.shape.borderRadius,
        border: `1px solid ${theme.palette.divider}`,
        position: 'relative',
        boxShadow: theme.shadows[4],
        overflow: 'hidden',
        '& img': {
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
        },
        '& .title': {
            padding: theme.spacing(10, 0),
            zIndex: 1,
            color: 'white',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            background: 'rgba(0, 0, 0, .4)',
            '& h3': {
                fontWeight: 'bold',
            },
            '& h6': {
                textTransform: 'uppercase',
            }
        }
    }
}))